<script setup lang="ts">
import MainLayout from "views/layouts/MainLayout.vue";
import Loading from "vue-loading-overlay";
import IconeBds from "assets/img/icone_BDS.png";
import BannerAssineHorizontal from "components/HomePage/BannerAssineHorizontal.vue";
import JsonLD from "components/JsonLD.vue";
</script>
<template>
  <JsonLD :jsonOptions="jsonOptions"/>
  <MainLayout #="{ showModalMessages }">
    <div class="slot-body">
      <div class="container px-3">
        <loading v-model:active="loading" :is-full-page="false" color="#b20000" />
        <div class="row pt-3 align-items-center justify-content-center">
          <div class="box-title pt-3">
            <h1 class="title">{{ postsColumns.title }}</h1>
          </div>
        </div>
        <div class="row align-items-center justify-content-center">
          <div class="box-category">
            <span class="rectangle px-3 py-1 cursor-pointer">
              {{ postsColumns.category }}</span
            >
          </div>
        </div>
        <div class="row align-items-center justify-content-center">
          <img
            class="img-cover"
            :src="postsColumns.img"
            :alt="postsColumns.slug"
            width="806"
            height="537"
          />
        </div>
        <div class="row mt-3">
          <div class="col-lg-12 d-flex align-items-center justify-content-center">
            <div id="slot-post-api" v-html="postsColumns.content"></div>
          </div>
          <div class="col-lg-12 d-flex align-items-center justify-content-center">
            <div class="box-details">
              <div class="row justify-content-space-between">
                <p class="card-text small col-lg-3 col-12">
                  <font-awesome-icon :icon="['far', 'clock']" size="sm" /> {{ translate.publishedDate }} {{ postsColumns.schedule }}
                </p>
                <p class="card-text small col-lg-4 col-12">
                  <font-awesome-icon :icon="['far', 'clock']" size="sm" /> {{ translate.modifiedDate }} {{ postsColumns.date }}
                </p>
                <p class="card-text small col-lg-2 col-12">
                  <font-awesome-icon :icon="['far', 'comment-dots']" size="sm" />
                  {{ postsColumns.comments }}
                  {{ translate.commentsColumn }}
                </p>
                <div class="card-text col-lg-3 col-12 share-align">
                  <span>{{ translate.share }}</span>
                  <font-awesome-icon
                    :icon="['fas', 'share-nodes']"
                    size="sm"
                    style="color: #b20000; margin-left: 3px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-gray px-1">
        <div class="container">
          <div class="row d-flex align-items-center justify-content-center">
            <div class="box-w">
              <span class="title-comments" v-if="postsColumns.listComents.length">{{
                translate.commentAllBox
              }}</span>
              <div class="list-comentarios" v-if="postsColumns.listComents.length">
                <div
                  v-for="(comment, index) in postsColumns.listComents"
                  :key="index"
                  class="card-comment"
                >
                  <div>
                    <img
                      v-if="comment.ativo == 'true'"
                      :src="IconeBds"
                      alt="Assinante"
                      title="Assinante"
                      width="12"
                      height="12"
                    />
                    <span>
                      <strong>
                        {{ comment.name ? comment.name : (locale == "pt-br" ? "Anônimo" : "Anonymous") }}
                      </strong>
                    </span>
                    {{ translate.wroteOn }} {{ comment.date }}
                    <span class="a-answer text-answer" @click="toggle(comment)">
                      {{ translate.answer }}</span
                    >
                  </div>
                  <legend>{{ comment.comment }}</legend>
                  <hr />
                  <div
                    v-for="(commentAnswer, indexAnswer) in comment.answers"
                    :key="indexAnswer"
                    class="card-comment answer"
                  >
                    <div>
                      <img
                        v-if="commentAnswer.ativo == 'true'"
                        :src="IconeBds"
                        alt="Assinante"
                        title="Assinante"
                        width="12"
                        height="12"
                      />
                      <span>
                        <strong>
                          {{ commentAnswer.name ? commentAnswer.name : (locale == "pt-br" ? "Anônimo" : "Anonymous") }}
                        </strong>
                      </span>
                      {{ translate.wroteOn }} {{ commentAnswer.date }}
                    </div>
                    <legend>{{ commentAnswer.comment }}</legend>
                    <hr />
                  </div>
                  <div v-if="answered_comment_id === comment.id" class="box-w-2 answer">
                    <div class="questionario row">
                      <input
                        type="hidden"
                        class="form-control"
                        name="answered_comment_id"
                        v-model="answered_comment_id"
                      />
                      <span class="quest-title"> {{ translate.yoursComment }}</span>
                      <span class="quest-nickname" v-if="user.name">
                        {{ translate.yourNickname }} {{ user.nickname ?? user.name }} 
                        ( <a @click="showNicknameAnswer(user.nickname)" class="alter-nickname">{{ translate.alterNickName }}</a> )
                        <input v-if="nicknameCommentAnswerShow" class="form-control" required type="text" v-model="nicknameCommentAnswer">
                      </span>
                      <div class="row" v-else>
                        <div class="col-6">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              name="name"
                              :placeholder="translate.yourName"
                              v-model="nomeCommentAnswer"
                            />
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              name="email"
                              :placeholder="translate.yourEmail"
                              v-model="emailCommentAnswer"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-12 accept mt-3">
                          <input
                            type="checkbox"
                            name="acept"
                            id="acept"
                            v-model="newsletterCommentAnswer"
                          />
                          <label for="checkbox">{{ translate.formNewsCheck }}</label>
                        </div>
                      </div>
                      <div class="mb-3">
                        <textarea
                          class="form-control"
                          id="text-comment-bella"
                          :placeholder="translate.inputComment"
                          rows="5"
                          v-model="comentarioAnswer"
                        ></textarea>
                      </div>
                      <vue-recaptcha
                        ref="redAnswer"
                        v-if="showRecaptchaAnswer"
                        :sitekey="recaptchaSiteKey"
                        v-on:verify="recaptchaUpdatedAnswer"
                        hl="pt-br"
                      ></vue-recaptcha>
                      <a
                        class="button mt-2"
                        @click="saveCommentAnswer(showModalMessages)"
                      >
                        {{ translate.button }}
                        <i class="icon-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-w-2">
              <div class="questionario row">
                <span class="quest-title"> {{ translate.yoursComment }}</span>
                <span class="quest-nickname" v-if="user.name">
                  {{ translate.yourNickname }} {{ user.nickname ?? user.name }} 
                  ( <a @click="showNickname(user.nickname)" class="alter-nickname">{{ translate.alterNickName }}</a> )
                  <input v-if="nicknameCommentShow" class="form-control" required type="text" v-model="nicknameComment">
                </span>
                <div class="row" v-else>
                  <div class="col-6">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        name="cpf"
                        :placeholder="translate.yourName"
                        v-model="nomeComment"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        name="cpf"
                        :placeholder="translate.yourEmail"
                        v-model="emailComment"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-12 accept mt-3">
                    <input
                      type="checkbox"
                      name="acept"
                      id="acept"
                      v-model="newsletterComment"
                    />
                    <label for="checkbox">{{ translate.formNewsCheck }}</label>
                  </div>
                </div>
                <div class="mb-3">
                  <textarea
                    class="form-control"
                    id="text-comment-bella"
                    :placeholder="translate.inputComment"
                    rows="5"
                    v-model="comentario"
                  ></textarea>
                </div>
                <vue-recaptcha
                  ref="red"
                  v-if="showRecaptcha"
                  :sitekey="recaptchaSiteKey"
                  v-on:verify="recaptchaUpdated"
                  hl="pt-br"
                ></vue-recaptcha>
                <a
                  class="button mt-2"
                  href="#"
                  @click.prevent="saveComment(showModalMessages)"
                >
                  {{ translate.button }}
                  <i class="icon-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row pb-5 pt-5 d-flex align-items-center justify-content-center">
          <BannerAssineHorizontal :path="bannerAssineHorizontal" />
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import translaters from "tradutors/columns";
import { localeStore } from "stores/locale";
import { mapState, mapActions } from "pinia";
import api from "../../api";
import { userStore } from "../../stores/user";
import vueRecaptcha from "vue3-recaptcha2";
import router from "router"
import { isMobile } from "../shared/utils/mobile";

export default defineComponent({
  name: "ColumnSingle",
  components: {
    BannerAssineHorizontal,
  },
  computed: {
    ...mapState(localeStore, ["locale"]),
    ...mapState(userStore, ["user"]),
    translate: function () {
      if (this.locale === "pt-br") {
        return translaters.portugues;
      } else {
        return translaters.ingles;
      }
    },
  },
  watch: {
    locale: function () {
      this.getColunaId(this.$route.params.colunaId, false);
      this.getBannerAssineHorizontal(true);
    },
  },
  created() {
    const lang = ["pt-br", "en"];
    if (lang.indexOf(this.$route.params.locale) === -1) {
      window.location.replace("/");
    }
    this.getColunaId(this.$route.params.colunaId, true);
  },
  mounted() {
    this.getBannerAssineHorizontal();
  },
  head() {
    return {
      templateParams: {
        subTitle: null, 
        subPage: this.postsColumns.title ?? "Oi",
        page_url: window.location.origin + this.$route.fullPath,
        page_description: this.postsColumns.meta_description[0].content ?? "",
        page_image: this.postsColumns.cover,
        page_keywords:
          this.postsColumns.meta_keywords ??
          "bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site, bella blog",
        page_locale: this.locale,
        page_url_pt: "https://belladasemana.com.br/pt-br/colunas/"+this.$route.params.catergoriaId+"/"+this.postsColumns.alternate_slug_pt+"/"+this.$route.params.colunaId+"/"+this.postsColumns.alternate_pt,
        page_url_en: "https://belladasemana.com.br/en/colunas/"+this.$route.params.catergoriaId+"/"+this.postsColumns.alternate_slug_en+"/"+this.$route.params.colunaId+"/"+this.postsColumns.alternate_en,
        page_canonical: "https://belladasemana.com.br"+this.$route.fullPath,
      },
    };
  },
  data() {
    return {
      postsColumns: {
        title: "",
        slug: "",
        content: "",
        cover: "",
        date: "",
        schedule: "",
        comments: 0,
        category: "",
        img: "",
        listComents: [],
        meta_description: [
          {
            content: "",
          },
        ],
        meta_keywords: "",
      },
      loading: true,
      nomeComment: "",
      emailComment: "",
      newsletterComment: true,
      comentario: "",
      nicknameComment: "",      
      nicknameCommentShow: false,
      nomeCommentAnswer: "",
      emailCommentAnswer: "",
      newsletterCommentAnswer: true,
      comentarioAnswer: "",
      nicknameCommentAnswer: "",
      nicknameCommentAnswerShow: false,      
      answered_comment_id: "",
      showRecaptcha: true,
      showRecaptchaAnswer: true,
      loadingTimeout: 30000, // 30 seconds
      recaptcha: null,
      recaptchaAnswer: null,
      recaptchaSiteKey: "6LcqxykUAAAAADAOWqu2zCV2_uaW1IMDzoiKfn5J",
      bannerAssineHorizontal: "",
      jsonOptions: {
        type: '',
        headline: '',
        datePublished: '',
        dateModified: '',
        image: '',
        author: ''        
      },
      isMobile: isMobile(),      
    };
  },
  methods: {
    async getColunaId(id: string, isCreated) {
      this.loading = true;
      let url = "";      
      if (this.$route.query.preview == "true") url = "&preview=true";      
      api.get(`v1/colunas/getColumnId/${id}?language=${isCreated? this.$route.params.locale : this.locale}${url}`
        , { headers:{'X-Custom-Data': this.$cookies.isKey('commentUser') ? this.$cookies.get('commentUser') : ''}}
      ).then(({ data }) => {
        if (data.postsColumns[0]) {
          if (isCreated) {
            if (data.postsColumns[0].slug == this.$route.params.colunaName && 
                data.postsColumns[0].slugCategory == this.$route.params.categoriaName &&
                data.postsColumns[0].tag_id == this.$route.params.catergoriaId
                ) {
                  data.postsColumns[0].content = data.postsColumns[0].content.replace('https://admin', 'https://api')
                  this.postsColumns = data.postsColumns[0];
                  this.loading = false;
            } else {
              this.redirect('404')
            }
          } else {
            this.$router.replace({ params: { colunaName: data.postsColumns[0].slug, categoriaName: data.postsColumns[0].slugCategory } })
            .finally(() => {
              if (data.postsColumns[0].slug == this.$route.params.colunaName && 
                  data.postsColumns[0].slugCategory == this.$route.params.categoriaName &&
                  data.postsColumns[0].tag_id == this.$route.params.catergoriaId
                  ) {
                    data.postsColumns[0].content = data.postsColumns[0].content.replace('https://admin', 'https://api')
                    this.postsColumns = data.postsColumns[0];
                    this.loading = false;
              } else {
                this.redirect('404')
              }
            })          
          }
          this.jsonOptions = {
            type: 'NewsArticle',
            headline: data.postsColumns[0].title.replace(/\"/g, '\\"'),
            datePublished: data.postsColumns[0].scheduleTime,
            dateModified: data.postsColumns[0].dateTime,
            image: data.postsColumns[0].cover,
            author: this.locale == 'en' ? 'Bella Club' : 'Bella da Semana',
            url: this.locale == 'en' ? 'https://bellaclub.com' : 'https://belladasemana.com.br'
          }
        } else {
          this.redirect('404')
        }
      });
    },
    recaptchaExpired() {
      this.$refs.red.reset();
    },
    recaptchaExpiredAnswer() {
      this.$refs.redAnswer.reset();
    },
    recaptchaUpdated(recaptcha) {
      this.recaptcha = recaptcha;
    },
    recaptchaUpdatedAnswer(recaptcha) {
      this.recaptchaAnswer = recaptcha;
    },
    saveComment(message) {
      let form = {
        nome: this.nomeComment,
        email: this.emailComment,
        newsletter: this.newsletterComment,
        comentario: this.comentario,
        answered_comment_id: "",
        api: true,
        locale: this.locale,
      };

      if (this.nicknameCommentShow) {
        form["nickname"] = this.nicknameComment;
      } else {
        form["nickname"] = this.user.nickname;
      }

      form["g-recaptcha-response"] = this.recaptcha;

      if (!this.recaptcha)
        return message({
          message: {
            show: true,
            title: this.locale == "pt-br" ? "Erro" : "Error",
            textButton: this.locale == "pt-br" ? "Fechar" : "Close",
            textBoby:
              this.locale == "pt-br" ? "Preencha o Recaptcha!" : "Complete the Recaptcha",
          },
        });

      api
        .post(
          `v1/colunas/commentColumnId/${this.locale}/${this.$route.params.colunaId}`,
          form
        )
        .then(({ data }) => {
          if (this.nicknameCommentShow && this.nicknameComment != "") {
            api.get('v1/myaccount/getUser').then(({ data }) => {
              this.setUser(data);              
            })            
          }
          message({
            message: {
              show: true,
              title: this.locale == "pt-br" ? "Aviso" : "Notice",
              textButton: this.locale == "pt-br" ? "Fechar" : "Close",
              textBoby: data.message,
            },
          });
          if (data.userId) {
            this.$cookies.set('commentUser', btoa(data.userId), 1000 * 60 * 60 * 24 * 7)
          }
          this.nomeComment = "";
          this.emailComment = "";
          this.comentario = "";
          this.nicknameComment = "";
          this.nicknameCommentShow = false;
        })
        .catch((err) => {
          if (err.response.status === 400 && err.response.data.message)
            message({
              message: {
                show: true,
                title: this.locale == 'pt-br' ? 'Erro' : 'Error',
                textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close',
                textBoby: err.response.data.message
              }
            })
          else
            message({
              message: {
                show: true,
                title: this.locale == 'pt-br' ? 'Erro' : 'Error',
                textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close',
                textBoby:
                  this.locale == 'pt-br'
                    ? 'Falha ao enviar comentario!'
                    : 'Failed to send comment!'
              }
            })
        });

      this.recaptchaExpired();
    },
    saveCommentAnswer(message) {
      let form = {
        nome: this.nomeCommentAnswer,
        email: this.emailCommentAnswer,
        newsletter: this.newsletterCommentAnswer,
        comentario: this.comentarioAnswer,
        answered_comment_id: this.answered_comment_id,
        api: true,
        locale: this.locale,
      };

      if (this.nicknameCommentAnswerShow) {
        form["nickname"] = this.nicknameCommentAnswer;
      } else {
        form["nickname"] = this.user.nickname;
      }

      form["g-recaptcha-response"] = this.recaptchaAnswer;

      if (!this.recaptchaAnswer)
        return message({
          message: {
            show: true,
            title: this.locale == "pt-br" ? "Erro" : "Error",
            textButton: this.locale == "pt-br" ? "Fechar" : "Close",
            textBoby:
              this.locale == "pt-br" ? "Preencha o Recaptcha!" : "Complete the Recaptcha",
          },
        });

      api
        .post(
          `v1/colunas/commentColumnId/${this.locale}/${this.$route.params.colunaId}`,
          form
        )
        .then(({ data }) => {
          if (this.nicknameCommentAnswerShow && this.nicknameCommentAnswer != "") {
            api.get('v1/myaccount/getUser').then(({ data }) => {
              this.setUser(data);              
            })            
          }
          message({
            message: {
              show: true,
              title: this.locale == "pt-br" ? "Aviso" : "Notice",
              textButton: this.locale == "pt-br" ? "Fechar" : "Close",
              textBoby: data.message,
            },
          });
          if (data.userId) {
            this.$cookies.set('commentUser', btoa(data.userId), 1000 * 60 * 60 * 24 * 7)
          }
          this.nomeCommentAnswer = "";
          this.emailCommentAnswer = "";
          this.comentarioAnswer = "";
          this.answered_comment_id = "";
          this.nicknameCommentAnswer = "";
          this.nicknameCommentAnswerShow = false;
        })
        .catch((err) => {
          if (err.response.status === 400 && err.response.data.message)
            message({
              message: {
                show: true,
                title: this.locale == 'pt-br' ? 'Erro' : 'Error',
                textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close',
                textBoby: err.response.data.message
              }
            })
          else
            message({
              message: {
                show: true,
                title: this.locale == 'pt-br' ? 'Erro' : 'Error',
                textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close',
                textBoby:
                  this.locale == 'pt-br'
                    ? 'Falha ao enviar comentario!'
                    : 'Failed to send comment!'
              }
            })
        });
      this.recaptchaExpiredAnswer();
    },
    toggle: function (comment) {
      this.nomeCommentAnswer = "";
      this.emailCommentAnswer = "";
      this.newsletterCommentAnswer = true;
      this.comentarioAnswer = "";
      this.nicknameCommentAnswer = "";
      this.nicknameCommentAnswerShow = false;
      if (this.answered_comment_id == comment.id) {
        this.answered_comment_id = "";
      } else {
        this.answered_comment_id = comment.id;
      }
    },
    async getBannerAssineHorizontal(changeLanguage = false) {
      if (!sessionStorage.getItem("bannerAssineHorizontal") || changeLanguage)
      api.get(`v1/home/getBannerSuper?mobile=${isMobile()}&language=${this.locale}`).then(({ data }) => {
        this.bannerAssineHorizontal = data.bannerAssineHorizontal;
        sessionStorage.setItem(
            "bannerAssineHorizontal",
            JSON.stringify(this.bannerAssineHorizontal)
          );
      });
      else
        this.bannerAssineHorizontal = JSON.parse(
          sessionStorage.getItem("bannerAssineHorizontal")
        );
    },
    redirect(name) {
      router.push({
        name,
        params: {
          locale: this.locale
        }
      })
    },    
    showNickname(nickname) {
      this.nicknameComment = nickname
      this.nicknameCommentShow = true      
    },
    showNicknameAnswer(nickname) {
      this.nicknameCommentAnswer = nickname
      this.nicknameCommentAnswerShow = true      
    },
    ...mapActions(userStore, ['setUser']),    
  },
});
</script>
<style scoped lang="css">
label {
  height: 23px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 23px;
}

input[type="checkbox"] {
  position: relative;
  cursor: pointer;
  margin-inline: 15px;
  width: 20px;
  height: 20px;
}

input[type="checkbox"]:before {
  content: "";
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  top: -3px;
  left: -3px;
  background-color: #000;
}

input[type="checkbox"]:checked:before {
  content: "";
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  top: -3px;
  left: -3px;
  background-color: #000;
}

input[type="checkbox"]:checked:after {
  content: "";
  display: block;
  width: 9px;
  height: 15px;
  border: solid red;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 2px;
  left: 6px;
}

.form-group input {
  padding: 15px 20px;
  border-radius: 30px;
  background-color: #fff;
  font-size: small;
}

.form-control:focus {
  color: #000;
  background-color: #f8f8f8;
}

.rectangle {
  border-radius: 12px;
  background-color: #000000;
  color: #ffffff;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
  line-height: 15px;
}

.img-banner-rodape {
  height: 124px;
  width: 1012px;
}

.button {
  height: 50px;
  width: 170px;
  margin-bottom: 56px;
  cursor: pointer;
  border-radius: 30px;
  margin-left: 10px;
}

.quest-title {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
  margin-bottom: 5px;
}

.quest-nickname {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 16px;
}

.form-control {
  margin-top: 10px;
  background-color: #fff;
  color: #868686;
  font-size: 14px;
  font-weight: 600;
  font-family: "Exo-2";
}

.card-comment > div {
  font-family: "Roboto-Regular";
  font-size: 13px;
}

.card-comment > legend {
  font-family: "Roboto-Regular";
  font-size: 16px;
  line-height: 19px;
}

.card-comment > div > span {
  font-family: "Roboto-Bold";
  font-size: 13px;
  color: #000;
}

.card-comment > hr {
  margin-bottom: 10px !important;
}

.answer {
  padding-left: 50px !important;
}

.text-answer {
  color: #b20000 !important;
  font-size: 14px;
  cursor: pointer;
  padding-left: 10px;
}

.slot-body {
  margin-top: 65px !important;  
  background-color: #fff !important;
  text-align: justify;
}

#slot-post-api {
  max-width: 808px;
}

.list-comentarios {
  margin-top: 5px;
}

.list-comentarios img {
  width: 12px;
  margin-right: 5px;
  object-fit: cover;
}

.box-title {
  max-width: 808px;
  padding-inline: 0;
}

.box-category {
  max-width: 808px;
  padding-inline: 0;
  padding: 10px 0px;
}

.box-details {
  width: 808px;
  padding-inline: 0;
  margin-top: 20px;
  margin-bottom: 20px;  
}

.box-gray {
  background-color: #f8f8f8;
  width: 100%;
}

.box-details span {
  font-size: 16px;
  line-height: 19px;
  color: #666;
}

.box-w {
  margin-top: 50px;
  width: 808px;
  padding-inline: 0;
}

.box-w-2 {
  margin-top: 50px;
  width: 808px;
  padding-inline: 0;
}

.title-comments {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  line-height: 28px;
  padding-inline: 0;
}

.card-text {
  font-family: "Roboto-Regular";
  font-size: 13px;
  line-height: 15px;
  color: #999;
}

.title {
  font-family: "Roboto-Medium";
  font-size: 35px;
  line-height: 30px;
  color: #b20000;
}

.img-cover {
  max-width: 830px;
  height: auto;
}

:deep(#slot-post-api > h2 > span) {
  font-size: 24px !important;
  color: #000;
  font-weight: 700;
}

:deep(span) {
  font-family: "Roboto-Regular" !important;
}

:deep(strong) {
  font-family: "Roboto-Regular" !important;
}

:deep(b) {
  font-family: "Roboto-Regular" !important;
}

:deep(#slot-post-api > h2 > span) {
  font-size: 24px !important;
  color: #000;
  font-weight: bold;
}

.alter-nickname{
  color: #b20000;
  cursor: pointer;
  font-size: 13px;  
}

.share-align {
  display: flex;  
  justify-content: flex-end !important;
}  

:deep(.iframe-video-blog) {
  max-width: 808px !important;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .title {
    font-size: 36px;
    line-height: 40px;
  }

  .img-banner-rodape {
    height: unset;
    width: 90%;
  }

  .share-align {
    display: flex;    
    justify-content: flex-start !important;
  }  
  :deep(.iframe-video-blog) {
    width: 100% !important;
    height: 300px !important;
  }
}
</style>
